import React, { FunctionComponent } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';
import { useTranslation } from 'react-i18next';
import { useShareContext } from '../../context/ShareContext';

export type EmailShareProps = WithTrack & {
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

export const EmailShare: FunctionComponent<EmailShareProps> = ({
  className,
  track,
  trackingData,
  onClick,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { shareItems } = useShareContext();

  const trackClick = () => {
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'email',
      ...trackingData,
    });
    if (onClick) {
      onClick();
    }
  };

  return (
    <a
      data-qa="email-btn"
      href={`mailto:?subject=${encodeURIComponent(
        shareItems.email.subject,
      )}&body=${encodeURIComponent(shareItems.email.body)}`}
      onClick={trackClick}
      className={`jg-btn jg-btn--email ${className}`}
    >
      <span className="jg-sr-only">{t('common.shareBy')}</span>
      {t('common.email')}
    </a>
  );
};

export default withTrack(EmailShare);
